import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

/** ngx-translate root configuration (French only for now). */
export function provideAppTranslate() {
  return provideTranslateService({
    loader: provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
    fallbackLang: 'fr',
    lang: 'fr',
  });
}
